import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Surface, Tooltip, useSurfaceColorAtElevation } from '../../atoms';
import FloatingActionButton from '../../atoms/FloatingActionButton';
import { useTheme } from '@emotion/react';
import {} from 'react';
export const NavigationRailItem = (props) => {
    const theme = useTheme();
    const surfaceColor = useSurfaceColorAtElevation(x => x - 1);
    return (_jsx(Tooltip, { content: props.label, children: _jsx(FloatingActionButton
        // @ts-expect-error
        , { 
            // @ts-expect-error
            as: "li", "aria-label": props.label, containerColor: surfaceColor, hoverContainerColor: theme.color.onSurface, contentColor: theme.color.onSurface, hoverContentColor: surfaceColor, onClick: props.onClick, children: props.icon }) }));
};
const NavigationRail = Object.assign((props) => {
    const theme = useTheme();
    return (_jsxs(Surface, { as: "nav", css: [
            {
                display: 'flex',
                flexDirection: 'column-reverse',
                justifyContent: 'space-between',
                gap: '2rem',
                alignItems: 'center',
                borderRadius: theme.shape.large,
                padding: '4.8rem 2.2rem',
                width: 'fit-content',
                height: '100%',
                overflowY: 'auto',
            },
            props.header === undefined && {
                justifyContent: 'center',
            },
        ], children: [props.header ? _jsx("header", { css: { marginTop: '3rem' }, children: props.header }) : null, _jsx("div", { css: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1.2rem',
                }, children: props.children })] }));
}, { Item: NavigationRailItem });
export default NavigationRail;
//# sourceMappingURL=NavigationRail.js.map